import { useState, useCallback } from 'react';

export const useHeightRef = (
	defaultHeight = 0,
): {
	height: number;
	ref: (node: any) => void;
} => {
	const [height, setHeight] = useState(defaultHeight);
	const ref = useCallback((node: any): void => {
		node && setHeight(node.clientHeight);
	}, []);
	return { height, ref };
};
